import React, { useEffect, useState } from 'react'
import { postDataUserQuirofanos, postTurnosQuirofanos } from '../../../services/PaginaRuta';
import { fechaActual } from '../../../hooks/UseDate';
import ErrorEndpointComponent from '../../Error/ErrorEndpointComponent';
import axios from "axios";
import { useLocation } from 'react-router-dom';
import { UserTokenURL } from '../../../services/ApiHIS';
import ModalQuirofanoDetalle from './ModalQuirofanoDetalle';


const TurnosQuirofanos = () => {
  //const horas = Array.from({ length: 24 }, (_, i) => i);
  //const horas = Array.from({ length: 19 }, (_, i) => i + 6);
  const horas = Array.from({ length: 24 }, (_, i) => (i + 6) % 24);


  //const quirófanos = ['Quirófano A', 'Quirófano B', 'Quirófano C'];
  const [dataTurnosQuirofanos, setdataTurnosQuirofanos]=useState([])
  const [modalOnDisponibleOcupado, setmodalOnDisponibleOcupado]=useState(false)
  const [dataUser, setdataUser]=useState([])
  const [loading, setloading]=useState(false)
  const [errorEndpoint, seterrorEndpoint]=useState(false)
  const [filtroFecha, setfiltroFecha]=useState(fechaActual()) 
  //const [filtroFecha, setfiltroFecha]=useState(new Date())
  const [modalOnQuirofanoDetalle, setmodalOnQuirofanoDetalle]=useState(false)
  const [dataQuirofanoDetalle, setdataQuirofanoDetalle]=useState({
    nombreQuirofano:'',
    idQuirofano:''
  })
  //const [fechaFiltro, setfechaFiltro]=useState(fechaActual())

  // const estaOcupado = (quirófano, hora) => {
  //   if (quirófano === 'Quirófano A' && hora >= 15 && hora < 17) {
  //     return 'ocupado';
  //   } else if (quirófano === 'Quirófano A' && hora === 17) {
  //     return 'cupo';
  //   }
  //   return 'disponible';
  // };

  //token
  let query = new URLSearchParams(useLocation().search);
  let tokenCons = JSON.parse(query.get('token'));
  let location = useLocation();
  useEffect(() => {
    // Google Analytics
    //localStorage.removeItem('tokenReact');
    localStorage.setItem('tokenReact',tokenCons)
  }, [location]);

  useEffect(()=>{
    //console.log(tokenCons,'tokenConstokenCons')
    const url = UserTokenURL() 

    // Configurar la cabecera con el token JWT
    const headers = {
      Authorization: `Bearer ${tokenCons}`,
    };

    // Realiza la petición con Axios
    axios.get(url, { headers })
    .then(response => {
      //console.log(response.data.user_data, 'data user');

      // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
      localStorage.removeItem('usuarioInfo');
      console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
      // Guarda los nuevos datos
      localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));

      //console.log(localStorage.getItem('usuarioInfo'),'antessss')
      // Comprobación de los datos almacenados
      const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
      console.log(usuarioInfo.tipoUsuario, 'usuarioInfoStr')

      // Resto del código...
    })
    .catch(error => {
      console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
    });
  },[])

  // Estado para el modal
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const handleCellClick = (content,codigoQuiro,hora) => {
    setloading(false)
    //setModalContent(content);
    //console.log(codigoQuiro,'codigoQuiro')
    // Convierte el número a una cadena, añadiendo un cero al principio si es necesario
    const hourString = hora.toString().padStart(2, '0') + ":00:00";
    //console.log(hourString,'hourString')
    //dia en numero
    let hoy = new Date(selectedDate);
    let diaSemana = hoy.getDay();
    let diaAjustado = diaSemana + 1;  // Ajusta el valor para que el domingo sea 1, lunes sea 2, etc.
    
    // Si el día de la semana es domingo (0 en JS), ajusta el valor a 1
    diaAjustado = (diaAjustado === 7) ? 1 : diaAjustado;
    // const quirofanoUser=
    //   {
    //     "EMPCOD":"1",
    //     "ConsTpo":"QR",
    //     "ConsDia":diaAjustado,//"1",
    //     "TuQFchIng": `${selectedDate} 00:00:00`,
    //     "TuQFchSal": `${selectedDate} 00:00:00`,
    //     "DOCCOD":"RTQ",
    //     "MCDpto":"001",
    //     "ConsCod":codigoQuiro,
    //     "TuQHor":hourString,
    //     "TuQHorS":hourString
    // }
    const quirofanoUser={
      "ProFec":`${selectedDate} 00:00:00`,
      "ProFecF":`${selectedDate} 00:00:00`,
      "ProHorI":hourString,
      "ProHorF":hourString,
      'ProCons':codigoQuiro
  }
    //console.log(quirofanoUser,'data antes quirofanoUser')
    postDataUserQuirofanos(quirofanoUser).then((res)=>{
      console.log(res.data,' data user quirofano')
      setloading(true)
      if (res.data.length === 0) {
        // No hay data
        
        setmodalOnDisponibleOcupado(true)
        setModalContent(content);
      } else {
        // Hay data
        setModalOpen(true);        
        setdataUser(res.data.flat())
        
      }
    //   if (Array.isArray(res.data)) {
    //     // Lidiar con la primera forma de respuesta
    //     setModalOpen(true);
    //     const firstItem = res.data[0];
    //     setdataUser(res.data.flat())
    //     if (Array.isArray(firstItem) && firstItem.length > 0) {
    //         const data = firstItem[0];
            
    //     } else {
    //         console.error('Respuesta no válida:', res.data);
    //     }
    // } else if (res.data && typeof res.data === 'object' && res.data.mensaje) {
    //     // Lidiar con la segunda forma de respuesta
    //     const message = res.data.mensaje;
    //     console.log(message)
    //     setmodalOnDisponibleOcupado(true)
    //     setModalContent(content);
        
    // } else {
    //     console.error('Respuesta no válida:', res.data);
    // }
    })
    
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const closeModalDisponibleOcupado=()=>{
    setmodalOnDisponibleOcupado(false)
  }

  // Estado para la fecha seleccionada
  const [selectedDate, setSelectedDate] = useState(fechaActual());

  const handleDateChange = (e) => {
    
    setfiltroFecha(e.target.value)
  };

  const handleFilterClick = () => {
    // Aquí puedes agregar la lógica para filtrar los datos basados en la fecha
    console.log(`Filtrando por la fecha: ${selectedDate}`);
    setSelectedDate(filtroFecha);
  }

  useEffect(()=>{
   
    setloading(false)
    let hoy = new Date(selectedDate);
    let diaSemana = hoy.getDay();
    let diaAjustado = diaSemana + 1;  // Ajusta el valor para que el domingo sea 1, lunes sea 2, etc.
    
    // Si el día de la semana es domingo (0 en JS), ajusta el valor a 1
    diaAjustado = (diaAjustado === 7) ? 1 : diaAjustado;
    //console.log(diaAjustado,'diaAjustado')
    const turnosQuirofanos={ 
      //"EMPCOD":"1",
      "ConsTpo":"QR",
      "ConsDia":`${diaAjustado}`, //4
      "TuQFchIng":`${selectedDate} 00:00:00`,
      "TuQFchSal": `${selectedDate} 00:00:00`,
      "DOCCOD":"RTQ",
      //"MCDpto":"001"
  }
    postTurnosQuirofanos(turnosQuirofanos).then((res)=>{
      setloading(true)
      
    setdataTurnosQuirofanos(res.data)
    console.log(res.data,'setdataTurnosQuirofanos 1')
    }).catch((error)=>{
      seterrorEndpoint(true)
    })
  },[selectedDate])


  const estaOcupado = (index, hora) => {
    // Convierte el número a una cadena, añadiendo un cero al principio si es necesario
    const hourString = hora.toString().padStart(2, '0') + ":00";
    const horasOcupadasOConCupo = dataTurnosQuirofanos[index].DisponibilidadDeMinutos
    const hourStringNoDisponibles = hora.toString().padStart(2, '0') + ":00:00";
    const horasNoDisponibles = dataTurnosQuirofanos[index].horasNoDisponibles

    const updatedArray = horasOcupadasOConCupo.map(item => {
        const [hour, minute] = item.intervalo.split(':');
        return {
            ...item,
            intervalo: `${hour}:${minute}`
        };
    });

    const findHour = updatedArray.find(item => item.intervalo === hourString); 
    const isNoDisponible = horasNoDisponibles.includes(hourStringNoDisponibles)

    //if(findHour){

      if(isNoDisponible){
        return 'No disponible'
      }
      else if(findHour.minutosDisponibles <= 29){      
        return 'ocupado'
      }
      else if(findHour.minutosDisponibles >= 30 && findHour.minutosDisponibles <= 59){
        return 'cupo'
      }
    //}
  }

  

//   const estaOcupado2 = (index, hora) => {
//     // Convierte el número a una cadena, añadiendo un cero al principio si es necesario
//     const hourString = hora.toString().padStart(2, '0') + ":00:00";
//     const horaNoDisponiblesQuirofana = dataTurnosQuirofanos[index].horasNoDisponibles    
//     const nodisponibles = dataTurnosQuirofanos[index].horasOcupadas.flat()    
//     const inputTime = new Date(`1970-01-01T${hourString}Z`);
//     const inputHours = inputTime.getUTCHours();
   
//     // Función auxiliar para revisar un array de tiempo
//     const checkArray = (array) => {
//       let isHourFound = false;  // Variable para rastrear si se encontró una coincidencia de hora sin minutos
//       for (let i = 0; i < array.length; i++) {
//           const arrayTime = new Date(`1970-01-01T${array[i]}Z`);
//           const arrayHours = arrayTime.getUTCHours();
//           const arrayMinutes = arrayTime.getUTCMinutes();
          
//           if (inputHours === arrayHours) {
//               if (arrayMinutes === 0) {
//                   //return 'ocupado';
//                   isHourFound = true;  // Se encontró una coincidencia de hora sin minutos
//               } else {
//                   return 'cupo';
//               }
//           }
//       }
//       if (isHourFound) {
//         return 'ocupado';  // Si se encontró una coincidencia de hora sin minutos y no se encontró ninguna con minutos, retornar 'ocupado'
//     }
//       return null;
//   };

//   const checkArrayNoDisponible = (array) => {
//     let isHourFound = false;  // Variable para rastrear si se encontró una coincidencia de hora sin minutos
//     for (let i = 0; i < array.length; i++) {
//         const arrayTime = new Date(`1970-01-01T${array[i]}Z`);
//         const arrayHours = arrayTime.getUTCHours();
//         const arrayMinutes = arrayTime.getUTCMinutes();
        
//         if (inputHours === arrayHours) {
//             if (arrayMinutes === 0) {
//                 //return 'ocupado';
//                 isHourFound = true;  // Se encontró una coincidencia de hora sin minutos
//             } else {
//                 return 'cupo';
//             }
//         }
//     }
//     if (isHourFound) {
//       return 'No disponible';  // Si se encontró una coincidencia de hora sin minutos y no se encontró ninguna con minutos, retornar 'ocupado'
//   }
//     return null;
// };
  
//   // Revisar el primer array
//   const result1 = checkArrayNoDisponible(horaNoDisponiblesQuirofana);
//   if (result1) {
//       return result1;
//   }
  
//   const arrayHorasIntermedias = agregarHorasIntermedias(nodisponibles)
//   //console.log(arrayHorasIntermedias,'arrayHorasIntermedias')
//   // Revisar el segundo array
//   const result2 = checkArray(arrayHorasIntermedias);
//   if (result2) {
//       return result2;
//   }
  
//   return 'disponible';
    
//   };


  //
//   function agregarHorasIntermedias(arr) {
//     // Crea un array vacío 'resultado' para almacenar las horas resultantes
//     let resultado = [];
//     // Itera a través del array de horas dado en pasos de 2 (i += 2)
//     for (let i = 0; i < arr.length; i += 2) {
//         // Divide la hora inicial en componentes (horas, minutos, segundos) y convierte los componentes a números
//         let horaInicio = arr[i].split(':').map(Number);
//         // Divide la hora final en componentes (horas, minutos, segundos) y convierte los componentes a números
//         let horaFinal = arr[i + 1].split(':').map(Number);

//         // Continúa mientras la hora de inicio sea menor que la hora final
//         while (horaInicio[0] < horaFinal[0] || (horaInicio[0] === horaFinal[0] && horaInicio[1] < horaFinal[1])) {
//             // Une los componentes de la hora de inicio en una cadena, la rellena con '0' hasta 8 caracteres y la agrega al array 'resultado'
//             resultado.push(horaInicio.join(':').padEnd(8, '0'));
//             // Incrementa los minutos de la hora de inicio en 1
//             horaInicio[1] += 1;
//             // Si los minutos llegan a 60, incrementa las horas en 1 y reinicia los minutos a 0
//             if (horaInicio[1] === 60) {
//                 horaInicio[0] += 1;
//                 horaInicio[1] = 0;
//             }
//         }
//         // Agrega la hora final al array 'resultado'
//         resultado.push(arr[i + 1]);
//     }
//     // Retorna el array 'resultado' que ahora incluye las horas intermedias
//     return resultado;
// }
// function agregarHorasIntermedias(arr) {
//   // Inicialización de un array vacío 'resultado' para almacenar las horas resultantes
//   let resultado = [];
//   // Iteración a través del array de horas dado en pasos de 2, tratando cada par de elementos como un rango de tiempo
//   for (let i = 0; i < arr.length; i += 2) {
//       // Descomposición de la hora inicial en horas y minutos, y conversión a números
//       let [horaInicio, minutoInicio] = arr[i].split(':').map(Number);
//       // Descomposición de la hora final en horas y minutos, y conversión a números
//       let [horaFinal, minutoFinal] = arr[i + 1].split(':').map(Number);

//       // Agrega la hora inicial al resultado
//       resultado.push(arr[i]);

//       // Encuentra la próxima hora completa después de la hora inicial
//       let proximaHoraCompleta = horaInicio + (minutoInicio > 0 ? 1 : 0);

//       // Agrega todas las horas completas entre la hora inicial y la hora final
//       for (let hora = proximaHoraCompleta; hora < horaFinal; hora++) {
//           let horaFormateada = (hora < 10 ? '0' : '') + hora + ':00:00';
//           resultado.push(horaFormateada);
//       }

//       // Agrega la hora final al resultado
//       resultado.push(arr[i + 1]);
//   }
//   return resultado;
// }

const handleQuirofanoDetalle = (nquirofano,iquirofano) =>{
  //console.log(quirofano,'quirofano')
  setmodalOnQuirofanoDetalle(true)
  setdataQuirofanoDetalle({
    nombreQuirofano:nquirofano,
    idQuirofano:iquirofano
  })
}

//const [date, setDate] = useState(new Date());

const handlePrevious = () => {
  setSelectedDate(prevDate => {
    const nuevaFecha = new Date(prevDate);
    nuevaFecha.setDate(nuevaFecha.getDate() - 1);
    return nuevaFecha.toISOString().split('T')[0];
  });
  setfiltroFecha(prevDate => {
    const nuevaFecha = new Date(prevDate);
    nuevaFecha.setDate(nuevaFecha.getDate() - 1);
    return nuevaFecha.toISOString().split('T')[0];
  });
};

const handleNext = () => {
  setSelectedDate(prevDate => {
    const nuevaFecha = new Date(prevDate);
    nuevaFecha.setDate(nuevaFecha.getDate() + 1);
    return nuevaFecha.toISOString().split('T')[0];
  });
  setfiltroFecha(prevDate => {
    const nuevaFecha = new Date(prevDate);
    nuevaFecha.setDate(nuevaFecha.getDate() + 1);
    return nuevaFecha.toISOString().split('T')[0];
  });
};

// useEffect(()=>{
//   function verificarDisponibilidad(horarios, hora) {
//     // Convertir la hora a verificar a un objeto Date para facilitar la comparación
//     const horaVerificar = new Date(`1970-01-01T${hora}Z`);
//     const treintaMinutosDespues = new Date(horaVerificar.getTime() + 30 * 60000); // 30 minutos después
  
//     let inicioEncontrado = false;
//     let finEncontrado = false;
  
//     for (let i = 0; i < horarios.length; i++) {
//       const inicio = new Date(`1970-01-01T${horarios[i][0]}Z`);
//       const fin = new Date(`1970-01-01T${horarios[i][1]}Z`);
  
//       // Verificar si la hora está ocupada
//       if ((horaVerificar >= inicio && horaVerificar < fin) || (treintaMinutosDespues > inicio && treintaMinutosDespues <= fin)) {
//         if (horaVerificar < inicio && treintaMinutosDespues > inicio) {
//           // Si la hora de inicio está después de la hora a verificar y antes de 30 minutos después, hay cupo
//           inicioEncontrado = true;
//         } else {
//           // La hora o la media hora siguiente está completamente ocupada
//           return 'ocupado';
//         }
//       }
//     }
  
//     // Si la hora de inicio está libre pero los siguientes 30 minutos están ocupados
//     if (inicioEncontrado && !finEncontrado) {
//       return 'con cupo';
//     }
  
//     // Si la hora no cae dentro de ningún rango, está disponible
//     return 'disponible';
//   }
  
//   // Ejemplo de uso
//   const horarios = [
//     ["07:00:00", "07:30:00"],
//     ["08:00:00", "08:30:00"],
//     ["09:00:00", "10:00:00"],
//     ["10:30:00", "11:00:00"],
//     ["11:30:00", "12:00:00"],
//     ["12:25:00", "13:00:00"],
//     ["14:00:00", "15:30:00"],
//     ["18:00:00", "19:00:00"]
//   ];
  
//   console.log(verificarDisponibilidad(horarios, "07:00:00")); // Debería mostrar "con cupo"
//   console.log(verificarDisponibilidad(horarios, "10:00:00")); // Debería mostrar "con cupo"
//   console.log(verificarDisponibilidad(horarios, "13:00:00")); // Debería mostrar "disponible"
  
  
  
  
  
    
// },[])

  return (
    <div className="min-h-screen  flex  justify-center">
      {isModalOpen && (
        <>
        <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40" onClick={closeModal}></div>
        <div className="fixed inset-0 flex items-center justify-center z-50 overflow-y-auto">
            <div className="bg-white p-2 sm:p-8 rounded shadow-lg  w-1/2 sm:w-3/4 md:w-3/4 lg:w-1/2">
                <h2 className="text-2xl mb-4">Pacientes</h2>
    
                <div className="pt-2 overflow-auto" >
                    <table className="w-full divide-y divide-gray-200 border border-gray-200 rounded">
                        <thead>
                            <tr>
                                <th className="py-2 px-4 border-b">Codigo cirugia</th>
                                <th className="py-2 px-4 border-b">Nombre</th>
                                <th className="py-2 px-4 border-b">Numero documento</th>
                                <th className="py-2 px-4 border-b">Hora inicial</th>
                                <th className="py-2 px-4 border-b">Hora final</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dataUser.map((item, index) => (
                                    <tr key={index}>
                                        <td className="py-2 px-4 text-xs">{item.ProCirCod}</td>
                                        <td className="py-2 px-4 text-xs">{item.MPNOMC}</td>
                                        <td className="py-2 px-4 text-xs">{item.MPCedu}</td>
                                        <td className="py-2 px-4 text-xs">{item.ProHorI}</td>
                                        <td className="py-2 px-4 text-xs">{item.ProHorF}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
    
                <div className="pt-4">
                    <button onClick={closeModal} className="bg-blue-500 text-white p-2 rounded hover:bg-blue-700">Cerrar</button>
                </div>
            </div>
        </div>
    </>
    
      
      )}
      {modalOnDisponibleOcupado && (
        <>
        <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40" onClick={closeModalDisponibleOcupado}></div>
        <div className="fixed inset-0 flex items-center justify-center z-50 overflow-y-auto">
          <div className="bg-white p-4 sm:p-8 rounded shadow-lg w-11/12 sm:w-3/4 md:w-1/2 lg:w-1/3">
            <h2 className="text-2xl mb-4">{modalContent}</h2>
            
            
            
            <div className="pt-4">
              <button onClick={closeModalDisponibleOcupado} className="bg-blue-500 text-white p-2 rounded hover:bg-blue-700">Cerrar</button>
            </div>
          </div>
        </div>
      </>
      )}
      <div className="w-full p-8 bg-white transition-colors duration-300 shadow-lg rounded-lg overflow-hidden border border-gray-200">
        <h1 className="text-4xl text-[#9e56fe] mb-6 font-semibold">Turnos Quirófanos</h1>
        {/* Input de fecha y botón de filtro */}
        <div className="mb-6 flex items-center">
          <label htmlFor="filterDate" className="mr-2 text-lg">Fecha:</label>
          <input 
            type="date" 
            id="filterDate" 
            value={filtroFecha} 
            onChange={handleDateChange} 
            className="p-2 border rounded-md mr-4" 
          />
          <button 
            onClick={handleFilterClick} 
            className="bg-[#9e56fe] text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
          >
            Filtrar
          </button>
          {/* <button 
            onClick={handleFilterClick} 
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors ml-3"
          >
            <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
</svg>
          </button> */}
          <button type="button" onClick={handlePrevious}
          className="ml-3 text-white bg-[#9e56fe] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5H1m0 0L5 1m-4 4L5 9"/>
            </svg>
            {/* <span class="ml-2">Anterior</span> */}
        </button>
          <button type="button" onClick={handleNext}
          className="ml-3 text-white bg-[#9e56fe] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm p-2.5 text-center inline-flex items-center me-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
{/* <span class="mr-2">Next</span> */}
<svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
</svg>
</button>
<div className="text-lg font-medium">
          {/* {date.toDateString()} */}
        </div>
        </div>
        

    
        <div className="flex justify-start items-center space-x-4 pb-3">
          <div className="flex items-center">
            <span className="mr-2">Ocupado/No Disponible</span>
            <div className="w-6 h-6 bg-red-500"></div>
          </div>
          <div className="flex items-center">
            <span className="mr-2">Con cupo</span>
            <div className="w-6 h-6 bg-yellow-500"></div>
          </div>
          <div className="flex items-center">
            <span className="mr-2">Disponible</span>
            <div className="w-6 h-6 bg-green-300"></div>
          </div>
          
        </div>
        <div className="overflow-x-auto">
         
          <table className="w-full divide-y divide-gray-200">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="sticky left-0 z-10 py-3 px-6 text-left bg-gray-800 	">Quirófanos / Horas</th>
                {horas.map((hora) => (
                  <th key={hora} className="py-3 px-6 text-left">{`${hora}:00`}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {dataTurnosQuirofanos.map((quirofano, index) => (
                <tr key={index} className="transition duration-200 hover:bg-gray-100">
                  <td className="sticky left-0 z-10 py-3 px-6 bg-white text-xs" onClick={() => handleQuirofanoDetalle(quirofano.NombreQuirofano,quirofano.CodigoQuirofano)}>{quirofano.NombreQuirofano ? quirofano.NombreQuirofano.trim() : null}</td>
                  {/* <td className="sticky left-0 z-10 py-3 px-6 bg-white text-xs">
                    <button onClick={() => handleQuirofanoDetalle(quirofano.NombreQuirofano)} >
                      {quirofano.NombreQuirofano ? quirofano.NombreQuirofano.trim() : null}
                    </button>
                  </td> */}
                  {horas.map((hora) => {
                    const estado = estaOcupado(index, hora);
                    return (
                      <td
                        key={hora}
                        onClick={() => handleCellClick(
                          estado === 'ocupado'? 'Esta Ocupado el Quirofano'
                            : estado === 'cupo'? 'Esta Con Cupo el Quirofano'
                            : estado === 'No disponible'? 'No esta disponible el Quirofano'
                            :'Esta Disponible el Quirofano',
                            quirofano.CodigoQuirofano,
                            hora
                        )}
                        className={`py-3 px-6 cursor-pointer hover:opacity-75 transition-opacity duration-150 text-xs ${
                          estado === 'ocupado'? 'bg-red-500 text-white'
                            : estado === 'cupo'? 'bg-yellow-500 text-white'
                            : estado === 'No disponible'? 'bg-red-500 text-white':'bg-green-300 text-black'
                        }`}
                      >
                        {estado === 'ocupado'
                          ? 'Ocupado'
                          : estado === 'cupo'
                          ? 'Con Cupo'
                          :  estado === 'No disponible'? 'No disponible':'Disponible'}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
          

        </div>
        

      </div>
      {
            loading? null:
            
            <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
          }
          {errorEndpoint && <ErrorEndpointComponent seterrorEndpoint={seterrorEndpoint} />}
          {modalOnQuirofanoDetalle? <ModalQuirofanoDetalle setmodalOnQuirofanoDetalle={setmodalOnQuirofanoDetalle} dataQuirofanoDetalle={dataQuirofanoDetalle} filtroFecha={filtroFecha}/>:null}
    </div>
  );
};
export default TurnosQuirofanos

// const array = [
//   {intervalo: "00:00:00 – 01:00:00", minutosDisponibles: 0},
//   {intervalo: "01:00:00 – 02:00:00", minutosDisponibles: 0},
//   {intervalo: "02:00:00 – 03:00:00", minutosDisponibles: 0},
//   {intervalo: "03:00:00 – 04:00:00", minutosDisponibles: 0},
//   {intervalo: "04:00:00 – 05:00:00", minutosDisponibles: 0},
//   {intervalo: "05:00:00 – 06:00:00", minutosDisponibles: 0},
//   {intervalo: "06:00:00 – 07:00:00", minutosDisponibles: 60},
//   {intervalo: "07:00:00 – 08:00:00", minutosDisponibles: 60},
//   {intervalo: "08:00:00 – 09:00:00", minutosDisponibles: 60},
//   {intervalo: "09:00:00 – 10:00:00", minutosDisponibles: 60},
//   {intervalo: "10:00:00 – 11:00:00", minutosDisponibles: 60},
//   {intervalo: "11:00:00 – 12:00:00", minutosDisponibles: 60},
//   {intervalo: "12:00:00 – 13:00:00", minutosDisponibles: 60},
//   {intervalo: "13:00:00 – 14:00:00", minutosDisponibles: 60},
//   {intervalo: "14:00:00 – 15:00:00", minutosDisponibles: 60},
//   {intervalo: "15:00:00 – 16:00:00", minutosDisponibles: 30},
//   {intervalo: "16:00:00 – 17:00:00", minutosDisponibles: 30},
//   {intervalo: "17:00:00 – 18:00:00", minutosDisponibles: 0},
//   {intervalo: "18:00:00 – 19:00:00", minutosDisponibles: 0},
//   {intervalo: "19:00:00 – 20:00:00", minutosDisponibles: 50},
//   {intervalo: "20:00:00 – 21:00:00", minutosDisponibles: 50},
//   {intervalo: "21:00:00 – 22:00:00", minutosDisponibles: 0},
//   {intervalo: "22:00:00 – 23:00:00", minutosDisponibles: 0},
//   {intervalo: "23:00:00 – 00:00:00", minutosDisponibles: 0}
// ];

// const updatedArray = array
//   .filter(item => {
//       const [hour] = item.intervalo.split(':');
//       return parseInt(hour, 10) >= 6;
//   })
//   .map(item => {
//       const [hour, minute] = item.intervalo.split(':');
//       return {
//           ...item,
//           intervalo: `${hour}:${minute}`
//       };
//   });

// //console.log(updatedArray,'ulotimoooo');
